import Validator from "./Validator";

export default class JsonEntitiesEntityDataIsBonusValidator extends Validator {
  constructor() {
    super();
    this.validationRules = {
      type: 'boolean',
      empty: false,
      mandatory: false
    };
  }
}
